import React from 'react';
import { motion } from 'framer-motion';
interface BonusGridProps {
  showFreeLabel?: boolean;
}
export function BonusGrid({
  showFreeLabel = false
}: BonusGridProps) {
  const bonuses = [{
    emoji: '🔥',
    number: 1,
    title: 'Calentamiento con Pelota',
    desc: '30 rutinas de activación dinámica desde el minuto 1'
  }, {
    emoji: '🥗',
    number: 2,
    title: 'Nutrición Ganadora',
    desc: 'Qué comer, cuándo y cómo hidratarse el día del partido'
  }, {
    emoji: '⚡',
    number: 3,
    title: 'Voley-Salto',
    desc: 'Programa de 8 semanas para ganar altura de salto sin gimnasio'
  }, {
    emoji: '💪',
    number: 4,
    title: 'Hombro de Acero',
    desc: 'Prevención de lesiones y protocolo pre-partido para rematadores'
  }, {
    emoji: '🔄',
    number: 5,
    title: 'Recuperación Express',
    desc: 'Protocolo post-partido para estar al 100% al día siguiente'
  }, {
    emoji: '📋',
    number: 6,
    title: 'Planificador 365',
    desc: 'Asistencia, scout, fichas, inventario y calendario anual'
  }];
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary" data-id="element-18">
      <div className="max-w-6xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-20">
          <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-21">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-xl text-text-secondary" data-id="element-22">
            Incluidos sin costo extra · Valor real del pack
          </p>
          {showFreeLabel && <div className="inline-block mt-4 px-6 py-3 bg-emerald-500/10 border border-emerald-500 rounded-full text-emerald-400 font-bold" data-id="element-23">
              🎁 GRATIS POR EL DÍA DE HOY
            </div>}
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-24">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-bg-card border border-border-card rounded-card p-6 hover:border-orange transition-colors relative" data-id="element-25">
              <div className="flex items-start gap-4" data-id="element-26">
                <div className="text-4xl" data-id="element-27">{bonus.emoji}</div>
                <div className="flex-1" data-id="element-28">
                  <h3 className="text-lg font-bold mb-2" data-id="element-29">
                    Bonus {bonus.number} — {bonus.title}
                  </h3>
                  <p className="text-text-secondary mb-3" data-id="element-30">{bonus.desc}</p>
                  <span className="inline-block px-3 py-1 bg-emerald-500/10 border border-emerald-500 rounded text-emerald-400 text-sm font-bold" data-id="element-31">
                    GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}